"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _indexModule = _interopRequireDefault(require("../../../static/styles/index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = require('capsule-core-js'),
    Isoxys = _require.Isoxys; // Setup CSS Module


var cx = _bind.default.bind(_indexModule.default);

const DEFAULT_STATE = {
  privateKey: '',
  error: null,
  loading: false
};

class PrivateKeyAsset extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "handleChange", e => {
      this.setState({
        privateKey: e.target.value,
        error: null
      });
    });

    _defineProperty(this, "handleSubmit", () => {
      this.checkPrivatekey(ok => {
        if (!ok) return this.setState({
          error: 'Invalid private key!'
        });
        this.returnDataToParent();
      });
    });

    _defineProperty(this, "checkPrivatekey", callback => {
      this.setState({
        loading: true
      }, () => {
        // Fetch the first address to know whether good file
        let options = {
          getApproval: window.kambriaWallet.getApproval,
          getPassphrase: window.kambriaWallet.getPassphrase
        };
        let isoxys = new Isoxys(window.kambriaWallet.networkId.ethereum, options);
        isoxys.getAccountByPrivatekey(this.state.privateKey, (er, re) => {
          this.setState({
            loading: false
          });
          if (er || re.lenght <= 0) return callback(false);
          return callback(true);
        });
      });
    });

    _defineProperty(this, "returnDataToParent", () => {
      return this.done({
        model: 'private-key',
        asset: {
          privateKey: this.state.privateKey
        }
      });
    });

    this.state = _objectSpread({}, DEFAULT_STATE);
    this.done = props.done;
  }

  componentWillUnmount() {
    // Clear history
    this.setState(_objectSpread({}, DEFAULT_STATE));
  }

  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: cx("tab-pane", "fade", "show", "active")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("form-group")
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "enter-private-key"
    }, "Enter Private Key"), /*#__PURE__*/_react.default.createElement("input", {
      className: cx("form-control"),
      type: "text",
      autoComplete: "off",
      id: "enter-private-key",
      placeholder: "Private Key",
      value: this.state.privateKey,
      onChange: this.handleChange
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: cx("form-group")
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: cx("text-danger")
    }, this.state.error)), /*#__PURE__*/_react.default.createElement("div", {
      className: cx("form-group")
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: cx("btn", "btn-sm", "btn-primary", "d-block", "text-left"),
      onClick: this.handleSubmit
    }, "OK")));
  }

}

var _default = PrivateKeyAsset;
exports.default = _default;